<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">学职生涯</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/carrerpostion' }"
        >学职定位</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ noTest[0].name }}测评</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box">
      <div class="content">
        <div class="top">
          <div class="top_content">
            <!-- 圆 -->
            <div
              class="circle"
              v-for="(it, ind) in list"
              :key="ind"
            >
              <div
                class="y1"
                :class="[it.name == noTest[0].name ? 'blue' : '']"
                :style="
                  it.status === 1 ? 'background:#68BF7B' : 'background:#F1F1F1'
                "
              >
                <div
                  class="y2"
                  :class="it.name === noTest[0].name ? 'blue1' : ''"
                  :style="
                    it.status === 1
                      ? 'background:#68BF7B;color:#fff'
                      : 'background:#F1F1F1;color:#333'
                  "
                >
                  {{ it.name }}
                </div>
              </div>
              <div class="x"></div>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="top_title">
            <div class="lefts"><img src="./images/left.png" alt="" /></div>
            <div class="centers">{{ noTest[0].name }}测试题</div>
            <div class="rights"><img src="./images/right.png" alt="" /></div>
          </div>
        </div>
        <div class="body">
          <div class="body_title">
            <div class="alarm_clock">
              <img src="./images/alarm_clock.png" alt="" />
            </div>
            <div class="body_state">{{ noTest[0].usesTime }}</div>
          </div>
          <div class="introduce">
            <div class="introduce_title">
              <div class="y"></div>
              <div class="introduce_state">测试介绍</div>
            </div>
            <div class="introduce_content">
              <p>
                {{ noTest[0].introduce }}
              </p>
            </div>
          </div>
          <div class="introduce">
            <div class="introduce_title">
              <div class="y"></div>
              <div v-if="noTest[0].name == '价值观'" class="introduce_state">
                选项参考
              </div>
              <div v-else class="introduce_state">测试应用</div>
            </div>
            <div class="introduce_content">
              <p>
                {{ noTest[0].application }}
              </p>
            </div>
          </div>
          <div class="introduce">
            <div class="introduce_title">
              <div class="y"></div>
              <div class="introduce_state">测试须知</div>
            </div>
            <div class="introduce_content">
              <p>
                {{ noTest[0].notice }}
              </p>
            </div>
          </div>
        </div>
        <div class="btn" @click="goMeasurement()">
          <button>开始测试</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getcustommaproccess } from "@/api/home";
export default {
  name: "XTesting",
  data() {
    return {
      list: "",
      noTest: [],
    };
  },

  async mounted() {
    const res = await getcustommaproccess(
      this.$store.state.user.studentInfo.userId
    );
    this.list = res.data || res.result.mapProccesses;
    await this.getNoTest();
  },

  methods: {
    goMeasurement() {
      this.$router.push({
        path: "/measurement",
        query: {
          noTestScaleId: this.noTest[0].scaleId,
        },
      });
    },
    getNoTest() {
      this.list.forEach((t) => {
        if (t.status != 1) {
          this.noTest.push(t);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 1050px;
  background-color: #fff;
  margin-top: 10px;
  min-width: 1050px;
  .content {
    width: 100%;
    padding-top: 25px;
    padding: 25px 40px 0 30px;
    box-sizing: border-box;
    .top {
      width: 100%;
      display: flex;
      justify-content: center;
      .top_content {
        display: flex;
        align-items: center;
        justify-content: center;
        .circle {
          display: flex;
          align-items: center;
          .blue {
            background: #cbd7fb !important;
          }
          .blue1 {
            background: #3964e6 !important;
            color: #fff !important;
          }
          .y1 {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 80px;
            background: #cbd7fb;
            opacity: 1;
            border-radius: 50%;
            .y2 {
              width: 66px;
              height: 66px;
              background: #3964e6;
              opacity: 1;
              text-align: center;
              line-height: 66px;
              border-radius: 50%;
              font-size: 16px;
              color: #333333;
              font-weight: bold;
            }
          }
          .x {
            width: 100px;
            height: 1px;
            background: #e8e8e8;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
          }
        }
        .circle:last-child .x {
          width: 0px;
        }
      }
    }
    .center {
      width: 100%;
      display: flex;
      margin-top: 48px;
      justify-content: center;
      .top_title {
        display: flex;
        align-items: center;
        .lefts {
          width: 40.21px;
          height: 21.21px;
        }
        .centers {
          font-size: 24px;
          color: #333;
          margin: 0 20px;
        }
        .rights {
          width: 40.21px;
          height: 21.21px;
        }
      }
    }
    .body {
      width: 100%;
      .body_title {
        display: flex;
        align-items: center;
        .alarm_clock {
          width: 15px;
          height: 15px;
          margin-right: 5px;
          img {
            width: 100%;
          }
        }
        .body_state {
          font-size: 16px;
          color: #ff3d00;
          font-weight: 600;
        }
      }
      .introduce {
        margin-top: 22px;
        .introduce_title {
          display: flex;
          align-items: center;
          .y {
            width: 14px;
            height: 14px;
            background: #3964e6;
            opacity: 1;
            border-radius: 50%;
            margin-right: 5px;
          }
          .introduce_state {
            font-size: 20px;
            color: #333;
            font-weight: bold;
          }
        }
        .introduce_content {
          margin-top: 9px;
          p {
            font-size: 18px;
            color: #666;
            margin-bottom: 10px;
          }
        }
      }
    }
    .btn {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 55px;
      button {
        width: 145px;
        height: 45px;
        background: #3964e6;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        border: 0;
        color: #fff;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
}
</style>
